<template>
  <div class="profile-basic-details">
    <SectionThreeItemsHeader class="mb-6 mt-2">
      <template v-slot:item-center>
        <h2>Criminal Convictions</h2>
      </template>
      <template v-slot:item-right>
        <EditCriminalConvictionsAction />
      </template>
    </SectionThreeItemsHeader>
    <TextWithVisibilityToggle
      label="Criminal Convictions"
      :text="userData.unspentCriminalConvictions || 'No'"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import TextWithVisibilityToggle from "@/components/common/BaseDetails/TextWithVisibilityToggle";
import EditCriminalConvictionsAction from "@/views/settings/components/actions/EditCriminalConvictionsAction";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  components: {
    TextWithVisibilityToggle,
    EditCriminalConvictionsAction,
    SectionThreeItemsHeader
  },
  computed: {
    ...mapState({
      userData: state => state.userData
    })
  }
};
</script>

<style lang="scss"></style>
